import * as FileSaver from 'file-saver';

const CSV_EXTENSION = '.csv';

export function exportAsCsvFile(data: any[], csvFileName: string): void {
  if (!data || data.length === 0) {
    console.warn('No Data Found');
    return;
  }

  const headers = Object.keys(data[0]);

  const csvRows = [
    headers.join(','),
    ...data.map((row) =>
      headers.map((field) => `"${row[field] ?? ''}"`).join(',')
    ),
  ];

  const csvString = csvRows.join('\n');

  const blob = new Blob([csvString], {
    type: 'text/csv;charset=utf-8;',
  });

  const fileName = `${csvFileName}_export_${new Date().toLocaleString('en-GB', {
    timeZone: 'Asia/Kolkata',
    hour12: true,
  })}${CSV_EXTENSION}`;

  FileSaver.saveAs(blob, fileName);
}
